
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.238 3.9a1.258 1.253 0 00-.829.364 1.258 1.253 0 000 1.77l7.744 7.711a1.259 1.253 0 001.778 0l7.744-7.711a1.258 1.253 0 000-1.77 1.258 1.253 0 00-1.777 0l-6.856 6.827-6.855-6.827a1.258 1.253 0 00-.95-.365z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    